<template>
  <Badge
    :title="item.fields.title"
    :size="item.fields.size"
    :style="style"
    :has-shine-animation="hasShineAnimation"
    v-bind="
      ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'title'
      })
    "
  >
    {{ item.fields.title }}
  </Badge>
</template>

<script setup lang="ts">
import { Badge } from '@hypercodestudio/basler-components';
import type { IBadge } from '~/lib/ContentfulService';
import { ContentfulLivePreview } from '@contentful/live-preview';

interface Props {
  item: IBadge;
}

const props = defineProps<Props>();

const style = computed<'primary' | 'secondary'>(
  () => props.item.fields.style ?? 'secondary'
);

const hasShineAnimation = computed(
  () => props.item.fields.shineAnimation === 'yes'
);
</script>
